import { ViaParam } from 'growth-onboarding-signup-redirect/types';
import { Integration } from 'signup-constants/Integration';
import { AppName } from 'signup-ui-lego-core/constants/AppName';
import { isIntegrationValid } from 'signup-ui-lego-core/utils/isIntegrationValid';
import { DefaultFlowOptions } from '../flow-initial/FlowOptions';
import { SignupApiFlowPath } from '../http-clients/SignupApiFlowPath';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { getHasIntegratedAppAuthSucceeded } from '../store/integrations/selectors';
import { isGoogleSignupSupported } from '../google-authentication/utils/isGoogleSignupSupported';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { LayoutType } from 'signup-components/types';
export const defaultIntegrationsFlowOptions = Object.assign({}, DefaultFlowOptions, {
  appName: AppName.Integrations,
  viaParam: ViaParam.IntegrationsSignup,
  oAuthsEnabled: {
    [OAuthProviders.Google]: isGoogleSignupSupported(),
    [OAuthProviders.Microsoft]: true,
    [OAuthProviders.Apple]: true
  }
});
const getGoogleWorkspaceAppFlowOptions = () => {
  return Object.assign({}, defaultIntegrationsFlowOptions, {
    shouldShowBoxAccountCard: true,
    shouldShowTitleOnExistingUserView: true,
    oAuthsEnabled: {
      [OAuthProviders.Google]: true,
      [OAuthProviders.Microsoft]: false,
      [OAuthProviders.Apple]: false
    },
    getLayoutType: () => LayoutType.CentredStep,
    shouldShowSignInButton: true
  });
};
const getShopifyEmbeddedFlowOptions = () => {
  return Object.assign({}, defaultIntegrationsFlowOptions, {
    shouldShowBoxAccountCard: true,
    shouldShowTitleOnExistingUserView: true,
    shouldShowSignInButton: false,
    canRedirect: state => getHasIntegratedAppAuthSucceeded(state)
  });
};
const getWordpressFlowOptions = () => {
  return Object.assign({}, defaultIntegrationsFlowOptions, {
    shouldShowBoxAccountCard: true,
    shouldShowTitleOnExistingUserView: true,
    shouldShowSignInButton: false,
    signupApiFlowPath: SignupApiFlowPath.Wordpress,
    appName: AppName.Wordpress,
    canRedirect: state => getHasIntegratedAppAuthSucceeded(state)
  });
};
export const getIntegrationFlowOptions = () => {
  const integrationKey = getIntegrationKey();
  if (!integrationKey || !isIntegrationValid(integrationKey)) {
    return defaultIntegrationsFlowOptions;
  }
  switch (integrationKey) {
    case Integration.GoogleWorkspaceApp:
      return getGoogleWorkspaceAppFlowOptions();
    case Integration.ShopifyEmbedded:
      return getShopifyEmbeddedFlowOptions();
    case Integration.Wordpress:
      return getWordpressFlowOptions();
    default:
      return defaultIntegrationsFlowOptions;
  }
};